import { COUNTRY } from './constants/RequestedDataTypes';
import { createRequestTypes, createRequestActions } from './helpers/RequestActions';
export const FetchCountryRequestTypes = createRequestTypes(COUNTRY);
export const FetchCountryActions = createRequestActions(FetchCountryRequestTypes);